module.exports = __webpack_public_path__ + "static/media/logo-s2-white2x_defi.e863e912.png";